import React from 'react';

import styled from '@emotion/styled';

import UserIcon from '../../../../components/Icons/UserIcon';
import ApplicantProfileModal from '../../../../components/Modal/ModalActions/ApplicantProfileModal';
import ModalTriggerContainer from '../../../../components/Modal/ModalTriggerContainer';
import { ModalProvider } from '../../../../context/ModalContext';
import { Modal } from '../../../../components/Modal/Modal';

const ShowApplicantModal = ({
  applicantId,
  applicationId,
  resume,
}: {
  applicantId: string;
  applicationId: string;
  resume: string;
}) => {
  return (
    <ModalProvider>
      <ModalTriggerContainer>
        <IconWrapper>
          <UserIcon />
        </IconWrapper>
      </ModalTriggerContainer>
      <Modal>
        <ApplicantProfileModal
          applicantId={applicantId}
          applicationId={applicationId}
          resume={resume}
        />
      </Modal>
    </ModalProvider>
  );
};

export default ShowApplicantModal;

const IconWrapper = styled.div`
  cursor: pointer;
`;
